export const is3dMode = window['IS_3D_MODE'];
